import { z } from 'zod';

/**
 * @function setToMidnight
 * @description Function to set the time of a date to midnight (00:00:00.000)
 */
const setDateToMidnight = (date: Date) => {
  const adjustedDate = new Date(date);
  adjustedDate.setHours(0, 0, 0, 0);
  return adjustedDate;
};

const searchBoxSchema = z
  .object({
    fromDate: z.date().optional(),
    toDate: z.date().optional(),
  })
  .refine(
    ({ fromDate, toDate }) => {
      if (fromDate && toDate) {
        return setDateToMidnight(toDate) >= setDateToMidnight(fromDate);
      }
      return true;
    },
    {
      message: 'COMMON:VALIDATIONS:DATE_VALUE_INVALID',
      path: ['toDate'],
    }
  )
  .refine(
    ({ fromDate }) => {
      if (fromDate) {
        const today = setDateToMidnight(new Date());
        return setDateToMidnight(fromDate) <= today;
      }
      return true;
    },
    {
      message: 'COMMON:VALIDATIONS:DATE_VALUE_INVALID',
      path: ['fromDate'],
    }
  );

export type SearchBoxSchema = z.infer<typeof searchBoxSchema>;

export default searchBoxSchema;
